import { render } from "./Sidebar_setting_component.vue?vue&type=template&id=6b42eab0&scoped=true"
import script from "./Sidebar_setting_component.vue?vue&type=script&lang=js"
export * from "./Sidebar_setting_component.vue?vue&type=script&lang=js"

import "./Sidebar_setting_component.vue?vue&type=style&index=0&id=6b42eab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b42eab0"]])

export default __exports__